import { render, staticRenderFns } from "./TechnicalHot.vue?vue&type=template&id=6bd64ee0&scoped=true&"
import script from "./TechnicalHot.vue?vue&type=script&lang=js&"
export * from "./TechnicalHot.vue?vue&type=script&lang=js&"
import style0 from "./TechnicalHot.vue?vue&type=style&index=0&id=6bd64ee0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd64ee0",
  null
  
)

export default component.exports